import React from 'react'

function ShareKnow() {
    return (
        <>
            <div className='container'>
                <div className='row my-5 align-items-center'>
                    <div className='col-md-4'>
                        <p className='about-us-year mb-0'>2007-2021</p>
                        <p className='about-us-title'>We share knowledge with the world</p>
                        <p className='about-us-description'>We are a team of passionate individuals dedicated to sharing knowledge and empowering others through education. Our mission is to make learning accessible and engaging for everyone, everywhere.</p>
                    </div>
                    <div className='col-md-8'>
                        <div className="d-flex justify-content-end">
                            <img src="/images/AboutUs1.png" alt="About Us" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShareKnow